import { StrictMode } from "react"
import ReactDOM from "react-dom/client"
import { LicenseManager } from "ag-grid-enterprise"
import "@workspace/ui/globals.css"
import { App } from "./App.tsx"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"

// Ensure AG Grid is licensed when dashboard hosts embedded apps
LicenseManager.setLicenseKey(import.meta.env.VITE_AGGRID_KEY)

ReactDOM.createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
)
// React is up: the index.html boot screen (the in-game spinner) goes.
document.getElementById("mofo-boot")?.remove()

// Enable PWA/offline support
serviceWorkerRegistration.register()
